"use client";
import {
  useCompositeGroupLabel
} from "../__chunks/FPZBL2HG.js";
import "../__chunks/7CGRXEUR.js";
import "../__chunks/7HVFURXT.js";
import {
  createElement,
  createHook,
  forwardRef
} from "../__chunks/YIF72NQG.js";
import "../__chunks/OPTPHWV7.js";
import "../__chunks/4ROCFRIN.js";
import "../__chunks/4R3V3JGP.js";

// src/menu/menu-group-label.tsx
var TagName = "div";
var useMenuGroupLabel = createHook(
  function useMenuGroupLabel2(props) {
    props = useCompositeGroupLabel(props);
    return props;
  }
);
var MenuGroupLabel = forwardRef(function MenuGroupLabel2(props) {
  const htmlProps = useMenuGroupLabel(props);
  return createElement(TagName, htmlProps);
});
export {
  MenuGroupLabel,
  useMenuGroupLabel
};
